import { useGetCurrentUserQuery } from '@carboncopyco/data';
import { DownOutlineIcon, VOutlineIcon } from '@carboncopyco/icons';
import type { ShareSecurityLevel } from '@carboncopyco/types';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { getAccessLevels } from './consts';

type AccessItemProps = {
  accessLevel: ShareSecurityLevel;
  disabled?: boolean;
} & (
  | { isSelected: boolean; variant?: 'option' }
  | { isSelected?: never; variant?: 'trigger' }
);

export const SecurityItem = ({
  accessLevel,
  variant = 'option',
  isSelected = false,
  disabled,
}: AccessItemProps) => {
  const { data: userResponse } = useGetCurrentUserQuery();
  const { user } = userResponse || {};
  const emailDomain = user?.email?.split('@')[1];

  const accessLevels = getAccessLevels(emailDomain);
  const Icon = accessLevels[accessLevel].icon;
  const color = disabled
    ? ColorHex.natural300
    : variant === 'option'
      ? ColorHex.natural600
      : ColorHex.primary300;
  const dsColor = disabled
    ? 'text-ds-natural-300'
    : variant === 'option'
      ? 'text-ds-natural-600'
      : 'text-ds-primary';
  return (
    <div
      className={classNames(
        'py-3 px-5 flex items-center justify-between rounded-lg',
        {
          'bg-ds-natural-50': variant === 'trigger',
          'cursor-not-allowed': disabled,
          'cursor-pointer': !disabled,
        }
      )}
    >
      <div className="flex items-center gap-4">
        <div className={classNames('flex items-center', dsColor)}>
          <Icon
            color={color}
            size={30}
          />
        </div>
        <div className="flex flex-col items-start">
          <div className={classNames('flex items-center gap-2', dsColor)}>
            <TextBase
              color={dsColor}
              label={accessLevels[accessLevel].label}
            />
            {variant === 'trigger' && <DownOutlineIcon />}
          </div>
          <TextBase label={accessLevels[accessLevel].description} />
        </div>
      </div>
      {isSelected && <VOutlineIcon size={30} />}
    </div>
  );
};
